(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name patternLimitation.controller:PatternLimitationCtrl
	 *
	 * @description
	 *
	 */
	angular
	.module('patternLimitation')
	.directive('focusOn',function($timeout) {
    	return {
    		restrict : 'A',
    		link : function(vm,$element,$attr) {
    			vm.$watch($attr.focusOn,function(_focusVal) {
    				$timeout(function() {
    					_focusVal ? $element[0].focus() :
    						$element[0].blur();
                    });
                });
            }
    	}
    })
	.controller('PatternLimitationCtrl',PatternLimitationCtrl);

	function PatternLimitationCtrl(applicationConstants,
			PatternLimitationService, CommonMasterData, MessageService,
			PopupManager) {
		var vm = this;
		vm.ctrlName = 'PatternLimitationCtrl';

		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {},
			editorMode : applicationConstants.EDITOR_STATUS.ADD,
			masterList : {
				crewTypes : [],
				patternNames : []
			},
			patternLimitations : [],// grid data
			selectedPatternLimitation : PatternLimitationService
					.getPatternLimitationDTO(),
			addedPatterns : []
		};

		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search and set search results
		vm.submitSearchPatternLimitation = function(searchParams) {
			clearEditPanal();
			vm.model.initialSearchDone = false;
			vm.model.searchCriteria = searchParams;
			PatternLimitationService
					.setPatternLimitationSearchRequest(vm.model.searchCriteria);
			searchPatternLimitations();
		};

		// search Pattern Limitations
		function searchPatternLimitations() {
			PatternLimitationService.getPatternLimitations(function(
					patternLimitations) {
				vm.model.patternLimitations = patternLimitations;
				vm.model.searchPanelToggle = false;
				vm.model.initialSearchDone = true;
			}, function(error) {
				MessageService.error(error);
			});
		}

		// when click on the new pattern limitation add
		vm.addNewPatternLimitation = function() {
			vm.model.searchPanelToggle = false;
			clearEditPanal();
		};

		// clear edit panal
		function clearEditPanal() {
			removeApendPatternNamesWhenAdd();
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
			vm.model.selectedPatternLimitation = PatternLimitationService
					.getPatternLimitationDTO();
			vm.model.masterList.patternNames = [];
		}

		// clear search panel data
		function clearSearchFeild() {
			vm.model.searchCriteria = {}
		}

		// when grid row is selected
		vm.selectARow = function(selectedRowData) {
			clearEditPanal();
			var searchReq = PatternLimitationService.getPatternLimitationSearchReq();
			loadPatternNameList(searchReq.crewType,selectedRowData);
			vm.model.searchPanelToggle = false;
			clearSearchFeild();
			vm.model.editorMode = applicationConstants.EDITOR_STATUS.EDIT
			vm.model.selectedPatternLimitation = PatternLimitationService
					.setPatternLimitationDTO(selectedRowData);
		};

		function appendSelectedPatternNamesToEditPanel(selectedRowData) {
			removeApendPatternNamesWhenAdd();
			vm.model.addedPatterns = PatternLimitationService
					.getPatternNameObjectsByPatternNameList(selectedRowData.patternNameList);
			var masterPatternNameList = vm.model.masterList.patternNames
					.concat(vm.model.addedPatterns);
			vm.model.masterList.patternNames = masterPatternNameList;
		}

		function removeApendPatternNamesWhenAdd() {
			if (!!vm.model.addedPatterns && vm.model.addedPatterns.length > 0) {
				for (var i = 0; i < vm.model.addedPatterns.length; i++) {
					vm.model.masterList.patternNames
							.splice(_.indexOf(vm.model.masterList.patternNames,
													_.findWhere(vm.model.masterList.patternNames,
																	{
																		patternName : vm.model.addedPatterns[i].patternName
																	})), 1);
				}
			}
			vm.model.addedPatterns = [];
		}

		// when editor panel field change
		vm.changeEditorField = function(selectedItem, flag) {
			if (selectedItem == undefined) {
				selectedItem = vm.model.selectedPatternLimitation;
			}
			if (flag === 'crewType' && !!selectedItem.crewType) {
				loadPatternNameList(selectedItem.crewType.crewTypeCode,null);
			}
		};

		// get pattern name list by crew type code
		function loadPatternNameList(crewTypeCode,selectedRowData) {
			var init=0;
			if(selectedRowData!=null && !!selectedRowData.patternNameList && selectedRowData.patternNameList.length>0){
				 init = selectedRowData.patternNameList.length;
			}
			if (!!crewTypeCode) {
				CommonMasterData
						.loadPatternNameListByCrewTypeCode(
								crewTypeCode,
								function(response) {
									if (!!response && response.length > 0) {
										vm.model.masterList.patternNames = PatternLimitationService
												.getFormattedPatternNames(response,init);
									} else {
										vm.model.masterList.patternNames = [];
									}
									if(selectedRowData!=null){
										appendSelectedPatternNamesToEditPanel(selectedRowData);
									}
								},
								function() {
									console
											.log('Pattern Name list retrieval error');
								});
			} else {
				vm.model.masterList.patternNames = [];
			}
		}

		// when click on save or delete
		vm.submitPatternLimitaion = function(action, selectedItem) {
			vm.model.selectedPatternLimitation = selectedItem;
			if (!!selectedItem && !!selectedItem.patternNames
					&& selectedItem.patternNames.length > 0) {
				if (action === applicationConstants.EDITOR_STATUS.DELETE) {
					if (!!selectedItem.patternLimitationId
							&& selectedItem.patternLimitationId != null) {
						var param = {
							title : 'Confirmation',
							messages : [ "Do you want to delete this record" ],
							flags : selectedItem
						};
						PopupManager.openModal('CONFIRM_DIALOG', param,
								confirmDeleteDialog);
					}
				} else if (action === applicationConstants.EDITOR_STATUS.ADD
						|| action === applicationConstants.EDITOR_STATUS.EDIT) {
					savePatternLimitation();
				}
			}
		};

		// delete pattern Limitation
		function confirmDeleteDialog(pass) {
			if (pass === 'YES') {
				PatternLimitationService
						.deletePatternLimitation(
								vm.model.selectedPatternLimitation,
								function(response) {
									if (response.success) {
										MessageService
												.success('Pattern Limitation is Successfully deleted!');
										if (vm.model.initialSearchDone) {
											searchPatternLimitations();
										}
										clearEditPanal();
									} else if (!!response.errors
											&& response.errors.length > 0) {
										MessageService
												.error(response.errors[0]);
									}
								}, function(error) {
									MessageService.error(error);
								});
			}
		}
		;

		// save pattern limitation
		function savePatternLimitation() {
			PatternLimitationService
					.savePatternLimitation(
							vm.model.selectedPatternLimitation,
							function(response) {
								if (response.success) {
									MessageService
											.success('Pattern Limitation is Successfully saved!');
									if (vm.model.initialSearchDone) {
										searchPatternLimitations();
									}
									clearEditPanal();
								} else if (!!response.errors
										&& response.errors.length > 0) {
									MessageService.error(response.errors[0]);
								}
							}, function(error) {
								MessageService.error(error);
							});
		}

		// get master data list
		(function() {
			// crew types
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.masterList.crewTypes = crewTypes;
			}, function() {
				console.log('Crew types retrieval error');
			});
		})();
	}
}());
